import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './components/App/App';

// const AppAsync = React.lazy(()=> import('./components/App/App'));

ReactDOM.render(
  <React.StrictMode>
    {/* <React.Suspense fallback={<h1>loading</h1>}>
      <AppAsync />
    </React.Suspense> */}
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

window.onbeforeunload = function () {
  window.scrollTo(0, 0);
}
